import { render, staticRenderFns } from "./ExpiredPassword.vue?vue&type=template&id=61209d9f&"
import script from "./ExpiredPassword.vue?vue&type=script&lang=js&"
export * from "./ExpiredPassword.vue?vue&type=script&lang=js&"
import style0 from "./ExpiredPassword.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ExpiredPassword.vue"
export default component.exports